import { addEditGridRow } from "./editGrid";
import { Luscinia, luscinia } from "./luscinia";

luscinia.executeActionList = async function (actions, form, initialTrigger) {
    var propertyGroup;
    if (actions !== undefined && actions !== null) {
        for (var i = 0; i < actions.length; ++i) {
            switch (actions[i].actionName) {
                case "ExecuteJavascript":
                    eval(actions[i].javascript);
                    break;
                case "ChangeSelect2DataUrl":
                    {
                        let inputElement = $(form).find("[name='" + actions[i].fieldName + "']");
                        if (inputElement.hasClass("luscinia-ajax-select")) {
                            // Treat empty GUID (00000000-0000-0000-0000-000000000000) as empty
                            const normalizeSelectValue = (v: any) =>
                                (!v || v === '' || v === '00000000-0000-0000-0000-000000000000') ? '' : String(v);
                            const isClearingUrl = normalizeSelectValue(actions[i].value) === '';
                            // The server re-issues ChangeSelect2DataUrl on every valuechanged round-trip.
                            // When neither the data url nor the value actually changed, re-initializing
                            // only tears down and rebuilds the select2 - and initializeAjaxSelect2 re-fires
                            // 'change', which posts valuechanged again, looping and collapsing an open
                            // dropdown mid-interaction. Skip the teardown when nothing changed.
                            if (inputElement.attr("data-luscinia-ajax-select-url") === actions[i].url &&
                                normalizeSelectValue(inputElement.val()) === normalizeSelectValue(actions[i].value)) {
                                break;
                            }
                            if (isClearingUrl) {
                                inputElement.find('option').remove();
                            }
                            inputElement.attr("data-luscinia-ajax-select-url", actions[i].url);
                            // Only destroy when actually initialized - destroying an uninitialized
                            // select2 crashes inside select2.min.js ("reading 'destroy'" on undefined).
                            if (inputElement.data('select2')) {
                                (inputElement as any).select2('destroy');
                            }
                            inputElement.val(actions[i].value);
                            luscinia.initializeAjaxSelect2(inputElement);
                        }
                    }
                    break;
                case "SetValue":
                    {
                        if (!initialTrigger) {
                            let inputElement = $(form).find("[name='" + actions[i].fieldName + "']").filter(":not(.luscinia-fileupload)");
                            // Special handling for select2 ajax fields to properly load and display the new value
                            if ((inputElement.hasClass("luscinia-ajax-select") || inputElement.hasClass("luscinia-inline-select")) && inputElement.hasClass("select2-hidden-accessible")) {
                                // Treat empty GUID (00000000-0000-0000-0000-000000000000) as empty
                                const normalizeSelectValue = (v: any) =>
                                    (!v || v === '' || v === '00000000-0000-0000-0000-000000000000') ? '' : String(v);
                                // The server echoes SetValue on every valuechanged round-trip, including
                                // when the field already holds the requested value (e.g. single-business-unit
                                // auto-select). Re-initializing tears down and rebuilds the select2, and
                                // initializeAjaxSelect2 re-fires 'change', which posts valuechanged again -
                                // a runaway destroy/reinit loop that collapses an open dropdown mid-interaction.
                                // Skip the teardown when nothing actually changed.
                                if (normalizeSelectValue(inputElement.val()) === normalizeSelectValue(actions[i].value)) {
                                    break;
                                }
                                // Always remove all options for clean state, especially important when clearing
                                inputElement.find('option').remove();
                                inputElement.val(actions[i].value);
                                if (inputElement.data('select2')) {
                                    (inputElement as any).select2('destroy');
                                }
                                if (inputElement.hasClass("luscinia-ajax-select")) {
                                    luscinia.initializeAjaxSelect2(inputElement);
                                } else {
                                    luscinia.initializeInlineSelect2(inputElement);
                                }
                            } else {
                                luscinia.setValue(form, actions[i].fieldName, actions[i].value);
                            }
                        }
                    }
                    break;
                case "SetEnabled":
                    {
                        let inputElement = $(form).find("[name='" + actions[i].fieldName + "']");
                        if (inputElement.hasClass("luscinia-ajax-select") || inputElement.hasClass("luscinia-inline-select")) {
                            inputElement.prop("disabled", !actions[i].enabled);
                            if (actions[i].enabled) {
                                inputElement.removeProp("readonly");
                            }
                        } else if (inputElement.attr("type") === "checkbox") {
                            inputElement.prop("disabled", !actions[i].enabled);
                            if (actions[i].enabled) {
                                inputElement.removeProp("disabled");
                            }
                        } else {
                            inputElement.prop("readonly", !actions[i].enabled);
                            if (actions[i].enabled) {
                                inputElement.removeProp("readonly");
                            }
                        }
                    }
                    break;
                case "SetRequired":
                    {
                        let inputElement = $(form).find("[name='" + actions[i].fieldName + "']");
                        var formGroup = inputElement.closest(".form-group.form-group-sm");
                        var label = formGroup.find("label");
                        if (label.hasClass("required")) {
                            if (!actions[i].required) {
                                label.removeClass("required");
                            }
                        }
                        else if (actions[i].required) {
                            label.addClass("required");
                        }
                    }
                    break;
                case "SetPropertyGroupEnabled":
                    propertyGroup = $("#" + form[0].id + "-luscinia-propertygroup-" + actions[i].propertyGroup.toLowerCase());
                    if (propertyGroup.length > 0) {
                        if (actions[i].Enabled) {
                            propertyGroup.removeClass("disabled");
                        } else {
                            propertyGroup.addClass("disabled");
                        }
                    }
                    break;
                case "SetPropertyGroupVisible":
                    propertyGroup = $("#" + form[0].id + "-luscinia-propertygroup-" + actions[i].propertyGroup.toLowerCase());
                    var allPropertyGroups = propertyGroup.parent().children();
                    var propertyGroupView = $(propertyGroup.find("a").attr("href"));
                    var allViews = propertyGroupView.parent().children();
                    if (propertyGroup.length > 0) {
                        if (actions[i].visible) {
                            propertyGroup.show();
                        } else {
                            if (propertyGroup.hasClass("active")) {
                                propertyGroup.removeClass("active");
                                propertyGroupView.removeClass("active");
                                allPropertyGroups.first().addClass("active");
                                allViews.first().addClass("active");
                            }
                            propertyGroup.hide();
                        }
                    }
                    break;
                case "SetHeaderMessage":
                    var modalMessage = $("#" + form[0].id + "-luscinia-modal-message");
                    var modalMessageText = modalMessage.find("#" + form[0].id + "-luscinia-modal-message-text");
                    if (actions[i].message === "") {
                        modalMessage.hide();
                        modalMessageText.text("");
                    } else {
                        var className = "alert-danger";
                        var imageClassName = "fa-times-circle";
                        switch (actions[i].messageType) {
                            case 0:
                                className = "alert-info";
                                imageClassName = "fa-info-circle";
                                break;
                            case 1:
                                className = "alert-success";
                                imageClassName = "fa-check";
                                break;
                            case 2:
                                className = "alert-warning";
                                imageClassName = "fa-exclamation-triangle";
                                break;
                            default:
                        }
                        modalMessage.find("i").removeClass().addClass("fa " + imageClassName + " sign");
                        modalMessage.removeClass().addClass("alert " + className);
                        if (actions[i].autoHideDelay !== 0) {
                            modalMessage.stop(true, true);
                            modalMessage.css("height", "auto").css("opacity", 1);
                            modalMessage.show(0).delay(actions[i].autoHideDelay).animate({ "opacity": 0, "height": 0 }, 500).hide(0).css("height", "auto").css("opacity", 1);
                        } else {
                            modalMessage.show();
                        }
                        modalMessageText.text(actions[i].message);
                    }
                    break;
                case "ReloadTableData":
                    {
                        const field = ($(form).find("[data-luscinia-field-name='" + actions[i].fieldName + "']") as any);
                        field.bootgrid("updateUrl", actions[i].url);
                        field.bootgrid("reload");
                    }
                    break;
                case "RerenderParameter":
                    if (!initialTrigger) {
                        luscinia.renderParameter(actions[i].parameterFullName, JSON.parse(actions[i].parameterData), actions[i].allowNullValues);
                    }
                    break;
                case "SetActiveWizardStep":
                    ($(".wizard") as any).wizard('selectedItem', actions[i].stepIndex + 1); //+1 because fuelix starts counting at 1
                    break;
                case "SetContainerContent":
                    setContainerContent("#" + actions[i].containerId, actions[i].content)
                    break;
                case "SetClosestFormGroupVisible":
                    {
                        let formGroup = $(form).find("[name='" + actions[i].childName + "']").closest(".form-group");
                        if (actions[i].visible) {
                            formGroup.show();
                        }
                        else {
                            formGroup.hide();
                        }
                    }
                    break;
                case "ShowNotificationModal":
                    luscinia.showNotificationModal(actions[i].title, actions[i].message);
                    break;
                case "ShowNotification":
                    luscinia.showNotification(actions[i].title, actions[i].message, actions[i].type);
                    break;
                case "ReloadEditGrid":
                    const editGridWrapper = $(`.editGrid-wrapper[name="${actions[i].propertyName}"]`)
                    const rows = editGridWrapper.find('.row.editGrid');
                    rows.each(function () {
                        luscinia.removeEditGridRow(this, false);
                    });

                    for (const row of actions[i].value.rows) {
                        await addEditGridRow(editGridWrapper, false, row, undefined, false);
                    }
                    break;
                case "UpdateBootGridColumn":
                    ($(form).find("[data-luscinia-field-name='" + actions[i].fieldName + "']") as any).bootgrid("setColumn", actions[i].rowIndex, actions[i].columnName, actions[i].value);
                    break;
                case "SetHidden":
                    {
                        const fieldName = actions[i].fieldName as string;
                        const value = actions[i].hidden as boolean;
                        if (value) {
                            $(form).find(`[name="${fieldName}"]`).closest('.form-group').hide();
                        }
                        else {
                            $(form).find(`[name="${fieldName}"]`).closest('.form-group').show();
                        }
                    }
                    break;
                case "SetDateConstraints":
                    {
                        let inputElement = $(form).find("[name='" + actions[i].fieldName + "']");
                        let dateTimePicker = inputElement.parent().data("DateTimePicker");
                        if (dateTimePicker) {
                            if (actions[i].minDate) {
                                dateTimePicker.minDate(new Date(actions[i].minDate));
                            } else {
                                dateTimePicker.minDate(false);
                            }
                            if (actions[i].maxDate) {
                                dateTimePicker.maxDate(new Date(actions[i].maxDate));
                            } else {
                                dateTimePicker.maxDate(false);
                            }
                        }
                    }
                    break;
                case "SetBootGridData":
                    ($(form).find("[data-luscinia-field-name='" + actions[i].fieldName + "']") as any).bootgrid("setRows", JSON.parse(actions[i].rows));
                    break;
                case "RenderForm":
                    const containerSelector = actions[i].containerSelector;
                    const content = actions[i].content;

                    setContainerContent(containerSelector, content);
                    luscinia.initFormElements(containerSelector, $(containerSelector).find("form"));
                    break;
                case "SetCurrencySymbol":
                    {
                        const fieldName = actions[i].fieldName;
                        const currencySymbol = actions[i].currencySymbol;

                        const field = $(form).find(`[name="${fieldName}"]`);
                        if (field.attr("editor-type") !== "currency") {
                            throw new Error(`SetCurrencySymbol can only be called on a editor type currency field`)
                        }

                        field.siblings(".luscinia-currency-sign").text(currencySymbol);
                    }
                    break;
                case "SetImageSrc":
                    setImageSrc(form, actions[i].fieldName, actions[i].value);
                    break;
            }
        }
    }
}

function setImageSrc(form: any, fieldName: string, value: string) {
    const propertyContainer = $(form).find(`.property-container:has([name=${fieldName}])`);
    if (propertyContainer.length === 0) {
        throw new Error(`could not find the property with property name ${fieldName}`);
    }
    const image = propertyContainer.find("img");
    if (image.length === 0) {
        throw new Error("the field must be an image field");
    }
    image.attr("src", value);
}

function setContainerContent(containerSelector: string, content: string) {
    const container = $(containerSelector);
    if (container.length > 1) {
        throw new Error("There are multiple elements for this container selector there should be only one");
    }

    if (container.length === 0) {
        throw new Error(`Container element "${containerSelector}" not found`);
    }

    if (!isValidHTML(content)) {
        throw new Error("Invalid HTML content");
    }

    container.empty();
    container.append(content);
}

function isValidHTML(html: string): boolean {
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        return !doc.querySelector("parsererror");
    } catch {
        return false;
    }
}

Luscinia.prototype.setValue = function(filter, fieldName, value) {
    let inputElement = $(filter).find("[name='" + fieldName + "']").filter(":not(.luscinia-fileupload)");
    if (inputElement.hasClass("luscinia-ajax-select") || inputElement.hasClass("luscinia-inline-select")) {
        var multipleAttribute = inputElement.attr("multiple");
        if (multipleAttribute === undefined) {
            inputElement.val(value).trigger("change");
        }
        else {
            //Only pass an array if the element contains items otherwise pass an empty string
            if (value !== "") {
                inputElement.val(value.split(",")).trigger("change");
            }
            else {
                inputElement.val("").trigger("change");
            }
        }
    }
    else if (inputElement.attr("type") === "checkbox") {
        if (inputElement.is(':checked')) {
            if (value === "False") {
                inputElement.prop('checked', false); //To uncheck the radio button
            }
        }
        else {
            if (value === "True") {
                inputElement.prop('checked', true);  //To check the radio button
            }
        }
    }
    else if (inputElement.parent().hasClass("datetime")) {
        if (value === "") {
            inputElement.parent().data("DateTimePicker").date(null);
            return;
        }
        let dateFormat = inputElement.data("date-format");
        if (dateFormat === "L") {
            inputElement.parent().data("DateTimePicker").date(new Date(value).toLocaleDateString(luscinia.config.culture));
        }
        else if (dateFormat === "L LT") {
            inputElement.parent().data("DateTimePicker").date(new Date(value).toLocaleString(luscinia.config.culture));
        }
    }
    else if (inputElement.hasClass("luscinia-htmleditor"))
    {
        const targetElement = ($(filter).find("[name='" + fieldName + "']") as any);
        targetElement.summernote('code', value);
    }
    else {
        inputElement.val(value);
    }
}
